<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div class="user-container">
    <ram-card :data="userData" />
    <div class="table">
      <a-input class="inp" placeholder="用户组名称" v-model:value="searchValue">
        <template #suffix>
          <img src="@/assets/svg/search.svg" alt="" />
        </template>
      </a-input>
      <user-table :data="detail" />
    </div>
  </div>
</template>
<script>
import Card from "@/components/dashboard/devops/ram/ram-card";
import Table from "@/components/dashboard/devops/ram/user-group/table";
import { getUserGroupList } from "@/api/dashboard/devops/ram/index";
import useApi from "@/utils/hooks/use-api";
import { Input } from "ant-design-vue";

import { reactive, ref, onMounted } from "vue";
export default {
  name: "ram-user-group",
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [Input.name]: Input
  },
  setup() {
    const { loading, result, fetchResource } = useApi(getUserGroupList);
    const detail = ref({});
    const searchValue = ref(null);
    const getList = async (params) => {
      await fetchResource(Object.assign({}, params));
      detail.value = result.value.data;
    };
    onMounted(async () => {
      await getList({});
    });

    const userData = reactive({
      name: "用户组",
      add: "+ 创建用户组",
      introduce: "通过用户组对类型相同的 RAM 用户进行分类并授权，可以更加高效地管理用户及其权限。",
      explain: `对一个用户组进行授权后，用户组内的所有用户会自动继承该用户组的权限。
如果一个用户被加入到多个用户组，那么该用户将会继承多个用户组的权限。。`
    });
    return { userData, getList, loading, detail, searchValue };
  }
};
</script>
<style scoped lang="less">
.user-container {
  .table {
    padding: 24px;
    text-align: left;
    background-color: #fff;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  }
  .inp {
    width: 274px;
    height: 32px;
    margin-bottom: 25px;
  }
}
</style>
